import React from "react";
import { Card, CardBody, Row, Col,CardHeader } from "reactstrap";
import SeccionCabecera from "../vista-tematicas-ambientales/seccion-cabecera-filtro";
import CardItem from "./card-item";
import Pagination from "react-js-pagination";
import Select from "components/forms/Select";
import { DataService } from "../../services/data.service";
import StringUtils from "../../commons/string-utils.module";
import Ubigeo from "../../commons/ubigeo.module";
import ProgressBar from "../../components/progress-bar/progress-bar.component";
import "./index.scss";
const default_type = [{ value: "", label: "Todos" }];
const DEFAULT_REGION_CODE = "00";
const DEFAULT_TEMATICA_CODE = "";
class VistaNormas extends React.Component {
  constructor(props) {
    super(props);
    let me = this;
    me.urlParams = StringUtils.getUrlParams(props.location.search);
    this.state = {
      isLoaded: false,
      items: [],
      ubigeo: me.getCodigoRegionInicial(),
      marco: me.getCodigoTematicaInicial(),
      page_current: 1,
      page_show: 10,
      page_size: 0,
      items_type: [],
      q1: "",
      q2: "",
      q3: "",
      loading: true
    };
    this.titulo = React.createRef();
    this.numero = React.createRef();
    this.handlePageChange = this.handlePageChange.bind(this);
    this.onChangeUbigeo = this.onChangeUbigeo.bind(this);
    this.onChangeMarco = this.onChangeMarco.bind(this);
    this.loadingData = this.loadingData.bind(this);
    this.handleType = this.handleType.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }
  componentDidMount() {
    let me = this;
    me.mounted = true;
    me.loadingData();
    DataService.getData(
      {
        query: "SNA07"
      },
      function (result) {
        if (me.mounted)
          if (result.SNA07.size > 0) {
            let store = [];
            store.push({
              value: "",
              label: "Todos"
            });
            result.SNA07.data.forEach(function (item) {
              store.push({
                value: item.nombre,
                label: item.nombre
              });
            });
            me.setState({
              items_type: store
            });
          }
      }
    );
  }
  componentWillUnmount() {
    let me = this;
    me.mounted = false;
  }
  getCodigoRegionInicial() {
    return (
      this.urlParams.region || DEFAULT_REGION_CODE
    );
  }
  getCodigoTematicaInicial() {
    return this.urlParams.tematica || DEFAULT_TEMATICA_CODE;
  }
  /**
   *
   * @param {Array} ubigeo
   */
  onChangeUbigeo(ubigeo) {
    let me = this;
    me.setState({
      ubigeo: ubigeo,
      loading: true,
      page_current: 1,
      page_show: 10,
      page_size: 0
    }, () => me.handlePageChange(me.state.page_current));
  }
  /**
   *
   * @param {String} marco
   */
  onChangeMarco(marco) {
    let me = this;
    me.setState({
      marco: marco,
      loading: true,
      page_current: 1,
      page_show: 10,
      page_size: 0
    }, () => me.handlePageChange(me.state.page_current));
  }
  handlePageChange(pageNumber) {
    let me = this;
    me.setState({ page_current: pageNumber, loading: true }, () =>
      me.loadingData()
    );
  }
  loadingData() {
    let me = this;
    DataService.getData(
      {
        query: "SNA05",
        ubigeo: me.state.ubigeo,
        marco: me.state.marco,
        pnum:
          me.state.page_show * parseInt(me.state.page_current) -
          me.state.page_show,
        psize: me.state.page_show * parseInt(me.state.page_current),
        q1: me.state.q1,
        q2: me.state.q2,
        q3: me.state.q3
      },
      function (result) {
        if (me.mounted)
          me.setState({
            items: result.SNA05.data,
            page_size: result.SNA05.size,
            loading: false
          });
      }
    );
  }
  handleType(e) {
    let me = this;
    me.setState({
      q1: e[0].value,
      loading: true,
      page_current: 1,
      page_show: 10,
      page_size: 0
    }, () => me.loadingData());
  }
  handleSearch(e) {
    if (e) {
      e.preventDefault();
    }
    let me = this;
    let search_numero = me.numero.current.value;
    if (search_numero.trim() !== "") {
      search_numero = search_numero.trim();
    } else {
      search_numero = "";
    }
    let search_titulo = me.titulo.current.value;
    if (search_titulo.trim() !== "") {
      search_titulo = search_titulo.trim();
    } else {
      search_titulo = "";
    }
    me.setState({
      q2: search_numero,
      q3: search_titulo,
      loading: true,
      page_current: 1,
      page_show: 10,
      page_size: 0
    }, () =>
      me.loadingData()
    );
  }
  handleKeyUp(e) {
    e.preventDefault();
    let me = this;
    me.handleSearch();
  }
  render() {
    let me = this;
    const {
      ubigeo,
      marco,
      items,
      page_current,
      page_show,
      page_size,
      items_type,
      loading
    } = this.state;
    return (
      <div>
        <Row>
          <Col>
            <Card>
            <CardHeader>
                <Row className="no-gutters">
                  <Col>
                    <div>
                      <h5>Normas</h5>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
            </Card>
          </Col>
        </Row>
        <SeccionCabecera
          scope={me}
          ubigeo={ubigeo}
          marco={marco}
          onChangeMarco={this.onChangeMarco}
          onChangeUbigeo={this.onChangeUbigeo}
          default={true}
        />
        <Row>
          <Col>
            <Card className="card-border-line">
              <CardBody>
                <Row>
                  <Col xs={12} sm={12} md={4} xl={4} style={{zIndex:500}}>
                    <Select
                      store={items_type}
                      item_default={default_type}
                      onChange={me.handleType}
                      placeholder="Seleccione un Tipo"
                    />
                  </Col>
                  <Col xs={12} sm={12} md={4} xl={3}>
                    <div className="form-group">
                      <input
                        type="text"
                        ref={me.numero}
                        className="form-control"
                        id="txt_codigo"
                        placeholder="Número de la norma"
                        onKeyUp={me.handleKeyUp}
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} xl={3}>
                    <div className="form-group">
                      <input
                        type="text"
                        ref={me.titulo}
                        className="form-control"
                        id="txt_titulo"
                        placeholder="Título de la norma"
                        onKeyUp={me.handleKeyUp}
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} xl={2}>
                    <div className="form-group">
                      <button
                        className="btn btn-primary mt-0 btn-action-text"
                        onClick={me.handleSearch}
                        type="button"
                      >
                        Filtrar
                      </button>
                    </div>
                  </Col>
                </Row>
                <div className="mb-1">
                  <ProgressBar active={loading} aniTime={"1"}></ProgressBar>
                </div>
                {items.length > 0 ? (
                  <div>
                    <div className="text-center mt-2">
                      {page_size} Normas
                     </div>
                    <CardItem items={items} />
                  </div>
                ) : (
                    <div>
                      {loading ? (
                        <div>
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                        </div>
                      ) : (
                          <div>
                            <br />
                            <div className="text-center">
                              <i className="fas fa-info-circle h3 text-primary" />
                            </div>
                            <div className="text-center">
                              <span className="h3  text-primary">
                                {" "}
                                No existe información para mostrar
                                  </span>
                            </div>
                          </div>
                        )}
                    </div>
                  )}
                <div className="text-align:center">
                  <Pagination
                    activePage={page_current}
                    itemsCountPerPage={page_show}
                    totalItemsCount={page_size}
                    onChange={this.handlePageChange}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default VistaNormas;
